

export function pageSizeOptions(): number[] {
    return [50, 100, 250];
}

export function itemsPerPageDefault(): number {
    return pageSizeOptions()[0];
}